import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import { Prompt } from "react-router";
import moment from "moment";

import { connect } from "react-redux";

import {
  DOCUMENT_TYPE_PHOTO,
  NOTE_TYPE_SSE,
  INTERVENTION_TYPES,
  INTERVENTION_TYPE_DEFAULT,
  interventionType,
} from "constants/dbValues";
import { Can } from "constants/abilityContext";
import { icons } from "constants/icons";
import {
  history,
  title,
  isChecked,
  validateProfileFields,
  selectProps,
  displayErrorContext,
  previewDocument,
  renderProjectSelectOption,
  dateTimeFormat,
} from "utils";

import { Header, DocumentsList } from "components";
import { Icon, Input, notification, Button, Checkbox, Select, Spin } from "antd";

import { noteService, projectService, documentService } from "services";

// Composant de détails d'un modèle.
// Beaucoup d'optimisation possible (React Modeling 04h11 pour code optimisé et centralisé).
//
// Les fonctions suivantes sont implémentées :
// - fetchSelects()
//   Fetch les options des dropdowns avec le selectService.
// - formatTag()
//   Render le html approprié selon les clés données dans le html.
//   En read render du static, en edit ou create render des inputs.
// - handleChange()
//   Gère le changement d'une valeur.
// - handleSubmit()
//   Gère le submit du form, tant en edit qu'en create.
// - validateFields()
//   Valide les champs du form qui sont required, utilise la fonction validateProfileFields
//   de utils/form.
// - render()
//   Render commun pour les 3 modes, la gestion des inputs se fait dans
//   formatTag(), mais les conditions plus générales se font directement dans render()
class SsePage extends Component {
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;

    this.state = {
      note: {
        __type: "Note",
        id: id,
        status: 1,
        type_id: NOTE_TYPE_SSE,
        intervention_type: INTERVENTION_TYPE_DEFAULT,
        documents: [],
      },
      uploading: false,
      errors: {},
      edited: false,
      projects: [],
      path: "sse",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  componentDidMount() {
    const { note, path } = this.state;
    const { edit, create } = this.props;

    this.doclist = React.createRef();

    if (!create) {
      noteService
        .get(note.id)
        .then((result) => {
          this.setState({ note: { ...note, ...result } });
        })
        .catch((e) => {
          history.push("/" + path);
        });
    }

    if (edit || create) this.fetchSelects();
  }

  async fetchSelects() {
    const projects = await projectService.list({
      order_by: "code,label",
      order_direction: "ASC,ASC",
      disabled: 0,
    });
    this.setState({ projects });
  }

  formatTag(key, fixed = false, label = "") {
    const { note, errors } = this.state;
    const { edit, create } = this.props;
    const noteData = { ...note }; // avoids undesirable state modification

    if ((!edit && !create) || (fixed && edit)) {
      if (key === "text" && noteData[key])
        noteData[key] = noteData[key].split("\n").map((item, key) => (
          <Fragment key={key}>
            {item}
            <br />
          </Fragment>
        ));

      switch (key) {
        case "project_id":
          return noteData.project ? (
            <Link to={`/projects/${noteData.project_id}`}>
              <Icon type={icons.project} />
              {`${noteData.project.label}`}
            </Link>
          ) : (
            ""
          );
        case "status":
          return isChecked(noteData[key]) ? (
            <>
              <Icon type="check-circle" />
              {label}
            </>
          ) : (
            ""
          );
        case "user_name":
          if ((noteData.user || {}).id == "99")
            return noteData.user ? <b> Visiteur : {noteData.visitor_name}</b> : <b></b>;
          else
            return noteData.user ? (
              <b>
                {(noteData.user || {}).name} {(noteData.user || {}).surname}
              </b>
            ) : (
              <b></b>
            );
        case "date":
          return <b>{noteData.date ? moment(noteData.date).format(dateTimeFormat) : ""}</b>;
        case "code":
          return <b>{noteData?.project?.code ?? ""}</b>;
        case "intervention_type": {
          const t = interventionType(noteData[key]);
          if (!t) return "";
          return <span className={`sse-type-tag sse-type-tag--${t.key}`}>{t.label}</span>;
        }
        default:
          return <b>{noteData[key]}</b>;
      }
    }

    var input;
    if (key === "status") {
      input = (
        <Checkbox
          name={key}
          checked={isChecked(noteData[key])}
          onChange={(e) => this.handleChange(e.target.checked, key)}
        >
          {label}
        </Checkbox>
      );
    } else if (key === "intervention_type") {
      input = (
        <Select
          value={noteData[key] || INTERVENTION_TYPE_DEFAULT}
          onChange={(value) => this.handleChange(value, key)}
          {...selectProps()}
          allowClear={false}
        >
          {INTERVENTION_TYPES.map((t) => (
            <Select.Option key={t.id} value={t.id}>
              {t.label}
            </Select.Option>
          ))}
        </Select>
      );
    } else if (key === "project_id") {
      const list = this.state.projects,
        computeLabel = renderProjectSelectOption;

      var options = list.map((t) => (
        <Select.Option key={t.id} value={t.id}>
          {computeLabel(t)}
        </Select.Option>
      ));

      input = (
        <Select
          value={noteData[key]}
          onChange={(value) => this.handleChange(value, key)}
          {...selectProps()}
        >
          {options}
        </Select>
      );
    } else {
      var Tag = key === "text" ? Input.TextArea : Input;
      let inputProps = key === "text" ? { autoSize: { minRows: 3, maxRows: 20 } } : null;

      input = (
        <Tag
          name={key}
          value={noteData[key]}
          {...inputProps}
          onChange={(e) => this.handleChange(e.target.value, key)}
        />
      );
    }

    var error = errors && errors[key];
    return <span className={error ? "error-wrap" : ""}>{input}</span>;
  }

  handleChange(value, key) {
    this.setState({
      note: { ...this.state.note, [key]: value },
      edited: true,
    });
  }

  handleSubmit() {
    if (!this.validateFields()) return;

    var note = { ...this.state.note };
    const { path } = this.state;
    const { edit, create } = this.props;

    var func;

    if (edit) {
      func = noteService.update;
    } else if (create) {
      func = noteService.create;
      note.date = new Date();
      note.created_by = this.props.user.id;
    }

    if (!note.status) note.status = 0;
    delete note.documents;

    const errorNotif = (e) => {
      this.setState({ uploading: false });
      notification.open({
        message: "Une erreur s'est produite",
        description: "Veuillez réessayer ou contacter un administrateur.",
        placement: "bottomRight",
      });
    };

    this.setState({ uploading: true }, () => {
      func(note)
        .then((n) => {
          this.doclist.current
            .executeActions(n.id, "Note")
            .then(() => {
              notification.open({
                message: "Enregistrement effectué",
                description: "Vos changements ont été enregistrés avec succès.",
                placement: "bottomRight",
              });

              this.setState({
                note: { ...note, ...n },
                edited: false,
                uploading: false,
              });
              history.replace(`/${path}/${n.id}`);
            })
            .catch((e) => errorNotif(e));
        })
        .catch((e) => errorNotif(e));
    });
  }

  validateFields() {
    const { note } = this.state;
    const { edit, create } = this.props;

    var fields = ["project_id", "text", "intervention_type"];
    var validation = validateProfileFields(note, fields);

    this.setState({ errors: validation.errors });
    return !validation.hasError;
  }

  render() {
    const { note, errors, path, uploading } = this.state;
    const { edit, create, type } = this.props;

    const term = "intervention",
      directPrefix = "l'",
      contentLabel = "Description de l’intervention SSE :";

    var mode = "read",
      pageTitle = `Détails d'une ${term}`,
      header = `${term[0].toUpperCase() + term.slice(1)} #${note.id}`,
      bread = [{ to: `/${path}`, text: `Liste des ${term}s` }, { text: note.id }];

    if (edit) {
      mode = "edit";
      pageTitle = `Édition d'une ${term}`;
      bread = [
        { to: `/${path}`, text: `Liste des ${term}s` },
        { to: `/${path}/${note.id}`, text: note.id },
        { text: "Édition" },
      ];
    } else if (create) {
      mode = "create";
      pageTitle = `Création d'une ${term}`;
      header = `Nouvelle ${term}`;
      bread = [{ to: `/${path}`, text: `Liste des ${term}s` }, { text: "Création" }];
    }

    return (
      <Fragment>
        <Helmet>{title(pageTitle)}</Helmet>

        <Header title={header} bread={bread} />

        <div className={`note-page main-content profile-content ${mode}`}>
          <Can do={mode} on={note}>
            <Spin
              indicator={<Icon type="loading" spin style={{ fontSize: "52px" }} />}
              spinning={uploading}
            >
              {mode === "read" && (
                <>
                  <ul className="tags">
                    <li>{this.formatTag("project_id")}</li>
                    <li className="alt">{this.formatTag("status", false, "Ouverte")}</li>
                  </ul>
                </>
              )}

              <ul className={"profile-main-content " + mode}>
                {mode === "create" ? (
                  <li>
                    <label>Projet :</label>
                    {this.formatTag("project_id", true)}
                  </li>
                ) : (
                  <li>
                    <label style={{ marginRight: 6 }}>Créée par :</label>
                    {this.formatTag("user_name", true)}
                  </li>
                )}
                <li>
                  <label style={{ marginRight: 6 }}>Type d'intervention :</label>
                  {this.formatTag("intervention_type")}
                </li>

                <li>
                  <label style={{ marginRight: 6 }}>Code du projet :</label>
                  {this.formatTag("code", true)}
                </li>

                {mode === "read" ? (
                  <li>
                    <label style={{ marginRight: 6 }}>Date :</label>
                    {this.formatTag("date", true)}
                  </li>
                ) : (
                  <></>
                )}

                <li className="note-content">
                  <label>{contentLabel}</label>
                  {this.formatTag("text")}
                </li>

                {mode !== "read" && (
                  <Fragment>
                    <li className="checkboxes">{this.formatTag("status", false, "Ouverte")}</li>
                  </Fragment>
                )}
              </ul>

              <DocumentsList
                ref={this.doclist}
                documents={note.documents}
                editable={edit || create}
                handleChange={this.handleChange}
              />

              {(edit || create) && (
                <Fragment>
                  {displayErrorContext(errors)}

                  <div className="buttons">
                    <Button type="link" onClick={() => history.goBack()}>
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      disabled={edit && !this.state.edited}
                      onClick={() => this.handleSubmit()}
                    >
                      {edit ? "Enregistrer les changements" : `Créer ${directPrefix}${term}`}
                    </Button>
                  </div>

                  <Prompt
                    when={this.state.edited}
                    message="Attention, certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?"
                  />
                </Fragment>
              )}

              {!edit && !create && (
                <div className="buttons">
                  <Button type="primary" onClick={() => history.push(`/${path}/${note.id}/edit`)}>
                    Éditer {directPrefix}
                    {term}
                  </Button>
                </div>
              )}
            </Spin>
          </Can>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.infos || {},
  };
};

export default connect(mapStateToProps, null)(SsePage);
